$(document).ready(function(){
	
	$("a[href*='#']:not([href='#'])").click(function() {
		
		var _decal = -80;
		
		if ( location.hostname == this.hostname && this.pathname.replace(/^\//,"") == location.pathname.replace(/^\//,"")	) {
			var anchor = $(this.hash);
			anchor = anchor.length ? anchor : $("[name=" + this.hash.slice(1) +"]");
			if ( anchor.length ) {
				$("html, body").animate( { scrollTop: anchor.offset().top + _decal }, 600);
			}
		}
	});
})